import { Zodios, makeApi } from "@zodios/core";
import axios from "axios";
import getURLPrefix from "../utils/getUrlPrefix";
import { gvadsApiDefinitions, amcApiDefinitions } from "./apiDefinitions/gvads";
import { experimentalApiDefinitions, pricingApiDefinitions } from "./apiDefinitions/pricing";
import { spApiCredentialCheckDefinitions } from "./apiDefinitions/api/spApiCredentialCheck";
import { workflowsApiDefinitions } from "./apiDefinitions/workflows";
import { shopifyApiDefinitions } from "./apiDefinitions/shopify";
import { appsApiDefinitions } from "./apiDefinitions/api/apps";

import { adsApiDefinitions, adReportApiDefinitions } from "./apiDefinitions/api/ads";
import { categoryReportApiDefinitions } from "./apiDefinitions/api/categoryReport";
import { orgReportApiDefinitions } from "./apiDefinitions/api/orgReport";
import { productReportApiDefinitions } from "./apiDefinitions/api/productReport";
import { pricingPlanReportApiDefinitions } from "./apiDefinitions/api/pricingPlanReport";
import { targetReportApiDefinitions } from "./apiDefinitions/api/targetReport";
import { productAdsApiDefinitions } from "./apiDefinitions/api/products";
import { auditLogApiDefinitions } from "./apiDefinitions/api/auditLogs";

import { ticketsApiDefinitions, exportCsvEndpoint } from "./apiDefinitions/api/tickets";
import { harvestersApiDefinitions } from "./apiDefinitions/api/harvesters";
import { portfoliosApiDefinitions } from "./apiDefinitions/api/portfolios";
import { scheduleSyncActionsApiDefinitions } from "./apiDefinitions/api/scheduleSyncActions";
import { queryApiDefinitions, stageApiDefinitions, queryStages } from "./apiDefinitions/api/query_funnel";
import { orgBulkActionApiDefinitions } from "./apiDefinitions/api/orgs";
import { profilesApiDefinitions } from "./apiDefinitions/api/profiles";
import { registrationApiDefinitions } from "./apiDefinitions/api/registration";
import { goalsApiDefinitions } from "./apiDefinitions/goals";
import { accountsApiDefinitions } from "./apiDefinitions/api/accounts";
import { organizationsApiDefinitions } from "./apiDefinitions/api/organizations";
import { userProfileApiDefinitions } from "./apiDefinitions/api/userProfile";
import { productAdApiDefinitions } from "./apiDefinitions/api/productAds";
import { storePageProductsApiDefinitions } from "./apiDefinitions/api/storePageProducts";
import { searchQueryPerformanceReportApiDefinitions } from "./apiDefinitions/api/searchQueryPerformance";
import { genaiApiDefinitions } from "./apiDefinitions/genai";
import { transcriptApiDefinitions } from "./apiDefinitions/api/transcripts";
import { trmnlApiDefinitions } from "./apiDefinitions/api/trmnl";
const apiDefinition = makeApi([
  ...gvadsApiDefinitions,
  ...pricingApiDefinitions,
  ...spApiCredentialCheckDefinitions,
  ...workflowsApiDefinitions,
  ...experimentalApiDefinitions,
  ...shopifyApiDefinitions,
  ...appsApiDefinitions,
  ...adReportApiDefinitions,
  ...adsApiDefinitions,
  ...productReportApiDefinitions,
  ...ticketsApiDefinitions,
  ...exportCsvEndpoint,
  ...pricingPlanReportApiDefinitions,
  ...categoryReportApiDefinitions,
  ...productAdsApiDefinitions,
  ...auditLogApiDefinitions,
  ...targetReportApiDefinitions,
  ...orgReportApiDefinitions,
  ...harvestersApiDefinitions,
  ...portfoliosApiDefinitions,
  ...scheduleSyncActionsApiDefinitions,
  ...queryApiDefinitions,
  ...stageApiDefinitions,
  ...queryStages,
  ...orgBulkActionApiDefinitions,
  ...profilesApiDefinitions,
  ...registrationApiDefinitions,
  ...goalsApiDefinitions,
  ...accountsApiDefinitions,
  ...organizationsApiDefinitions,
  ...userProfileApiDefinitions,
  ...productAdApiDefinitions,
  ...storePageProductsApiDefinitions,
  ...searchQueryPerformanceReportApiDefinitions,
  ...genaiApiDefinitions,
  ...transcriptApiDefinitions,
  ...amcApiDefinitions,
  ...trmnlApiDefinitions,
]);

export const apiClient = new Zodios(getURLPrefix(), apiDefinition, {
  axiosInstance: axios,
});
